import { render, staticRenderFns } from "./product-form.vue?vue&type=template&id=2d309dac&"
import script from "./product-form.vue?vue&type=script&lang=js&"
export * from "./product-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports